import { Divider, Tooltip } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import ButtonBackground from "images/button-background.svg";
import { ReactComponent as SendersActiveIcon } from "images/providers-active-icon.svg";
import { ReactComponent as SendersIcon } from "images/providers-icon.svg";
import * as FP from "utils/fp-js";
import { useReferralButton } from "./ReferralButton.hook";
import {
  ButtonContainer,
  ButtonIndicator,
  Container,
  EmptyLogoHolder,
  HalfHolder,
  Label,
  Led,
  Logo,
  LogoHolder,
  LogoSplash,
  Prop,
  TextMosaic,
  Value,
} from "./ReferralButton.style";
import { ReferralForm } from "./ReferralForm/ReferralForm";
import { useState } from "react";
import clsx from "clsx";
import { guideSteps } from "hooks/useOnboarding";

export const modes = {
  Skin: "Skin",
  Half: "Half",
  Logo: "Logo",
};

export const ReferralButton = ({
  data,
  setError,
  setCurrentButton = () => null,
  logo,
  mode,
  setNewLevel,
  setNewProgress,
  setNewCountsForUpdate,
  setLevelProgress,
  originator,
}) => {
  const [newReferral, setNewReferral] = useState(null);

  const {
    state,
    createNewReferral,
    handleReferralButtonClick,
    recipient,
    providers,
    isSendersSelected,
    isReferralSending,
  } = useReferralButton({
    data,
    setError,
    setNewLevel,
    setNewProgress,
    setNewCountsForUpdate,
    setLevelProgress,
    originator,
    setNewReferral,
  });

  return (
    <div
      className={clsx(
        guideSteps.BUTTON,
        guideSteps.BUTTON_QUESTION,
        "bg-white m-0 p-0 sm:p-4 border-0 sm:border-4 rounded-3xl border-dashed"
      )}
    >
      <Container>
        <ButtonContainer
          sx={{
            backgroundImage:
              logo && mode === modes.Skin
                ? `url("${logo}")`
                : `url("${ButtonBackground}")`,
          }}
        >
          {/* {!recipient?.isFlowSimplified && (
            <Stack
              alignItems={"flex-end"}
              sx={{
                margin: 0,
                position: "absolute",
                top: "-30px",
                right: "-30px",
              }}
            >
              <ActionMenu
                items={[
                  {
                    label: "View Details",
                    onClick: () => setSelectedButton(data[locationId]),
                  },
                ]}
              />
            </Stack>
          )} */}
          {FP.match(true)
            .on(
              mode === modes.Logo && !!logo,
              <Logo
                sx={{
                  backgroundImage: `url("${logo}")`,
                }}
              />
            )
            .on(
              mode === modes.Half && !!logo,
              <>
                <EmptyLogoHolder />
                <HalfHolder
                  sx={{
                    backgroundImage: `url("${logo}")`,
                  }}
                />
              </>
            )
            .otherwise(
              <>
                {logo ? (
                  <LogoSplash />
                ) : (
                  <LogoHolder>
                    <TextMosaic>
                      {[...Array(20)].map(() => recipient?.name).join(" ")}
                    </TextMosaic>
                  </LogoHolder>
                )}
              </>
            )}
          <Led className={state} />
          <ButtonIndicator onClick={createNewReferral} className={state}>
            {isReferralSending && <CircularProgress />}
          </ButtonIndicator>
        </ButtonContainer>
        {providers?.map(({ id, name, speciality }) => (
          <Prop key={`${id}-in-small-button`}>
            <Label>Provider: </Label>
            <Value>{[name, speciality].filter(Boolean).join(", ")}</Value>
          </Prop>
        ))}
        <Divider />
        <Prop>
          <Label>Recipient: </Label>
          <Value>{recipient?.name}</Value>
        </Prop>
        <Prop>
          <Label>Phone: </Label>
          <Value>{recipient?.phone}</Value>
        </Prop>
        <Tooltip title={"Manage Senders"}>
          <button
            onClick={() => setCurrentButton(data)}
            className="absolute -top-1 -left-2 w-8 h-8 p-1 bg-gray-200 rounded-full flex items-center justify-center hover:bg-gray-300 focus:outline-none"
          >
            {isSendersSelected ? <SendersActiveIcon /> : <SendersIcon />}
          </button>
        </Tooltip>
      </Container>
      {!!newReferral && (
        <ReferralForm
          newReferral={newReferral}
          setNewReferral={setNewReferral}
          handleReferralButtonClick={handleReferralButtonClick}
        />
      )}
    </div>
  );
};
